import React, { useState } from 'react';

function ShareButtons({ title, url }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    if (window.gtag) {
      window.gtag('event', 'share', {
        event_category: 'Engagement',
        event_label: 'copy_link',
        value: title,
      });
    }
  };

  const handleShare = (platform) => {
    if (window.gtag) {
      window.gtag('event', 'share', {
        event_category: 'Engagement',
        event_label: platform,
        value: title,
      });
    }
  };

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(`Check out this review: ${title}`)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    reddit: `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`,
  };

  return (
    <div className="flex flex-wrap gap-2 items-center">
      <span className="text-sm text-gray-600">Share this review:</span>
      {Object.entries(shareLinks).map(([platform, link]) => (
        <a
          key={platform}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleShare(platform)}
          className="px-3 py-1.5 rounded-md text-sm font-medium text-white transition-colors"
          style={{
            backgroundColor: {
              twitter: '#1DA1F2',
              facebook: '#4267B2',
              linkedin: '#0077B5',
              reddit: '#FF4500',
            }[platform],
          }}
        >
          {platform.charAt(0).toUpperCase() + platform.slice(1)}
        </a>
      ))}
      <button
        onClick={handleCopy}
        className="px-3 py-1.5 rounded-md text-sm font-medium bg-gray-200 text-gray-800 hover:bg-gray-300 transition-colors"
      >
        {copied ? 'Copied!' : 'Copy Link'}
      </button>
    </div>
  );
}

export default ShareButtons; 